import { render, staticRenderFns } from "./_base-display-text.vue?vue&type=template&id=29742041&"
import script from "./_base-display-text.vue?vue&type=script&lang=js&"
export * from "./_base-display-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports